import { UIHeading1 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as style from './style.css';
import { CollapseButton } from '../CollapseButton';

const LIMIT = 10;

export interface IFeaturesLayoutProps {
  title: string;
  noTopMargin?: boolean;
  children: React.ReactNode;
}

export const FeaturesLayout: React.FC<React.PropsWithChildren<IFeaturesLayoutProps>> = ({
  title,
  children,
  noTopMargin,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const childrenArray = React.Children.toArray(children);
  const hasMoreItemsThanLimit = childrenArray.length > LIMIT;
  const sliceLength = hasMoreItemsThanLimit && !isExpanded ? LIMIT : childrenArray.length;

  const handleToggle = React.useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  return (
    <div className={cn(style['container'], noTopMargin && style['container_no-top-margin'])}>
      <UIHeading1 as="h2" color="text-primary-default">
        {title}
      </UIHeading1>

      <div className={style['wrapper']}>{childrenArray.slice(0, sliceLength)}</div>

      {hasMoreItemsThanLimit && (
        <div className={style['collapse-button']}>
          <CollapseButton
            onClick={handleToggle}
            isCollapsed={!isExpanded}
            collapsedText="Показать всё"
            uncollapsedText="Скрыть всё"
          />
        </div>
      )}
    </div>
  );
};
